import React from 'react'
import { ContextNotification, Modal } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'
import { DateTime } from 'luxon'

import type { CoreDayReservableArea } from '../../../common/validations/contractDayReservableAreasSchema'
import { areaTitle, areaPriceFor } from './uiSelectors'
import { fmtCurrency } from './dayReservableAreas.helpers'

export interface DayReservableAreaSuccessProps {
  area: CoreDayReservableArea
  fromISO: string
}

export const DayReservableAreaSuccess: React.FC<
  DayReservableAreaSuccessProps
> = ({ area, fromISO }) => {
  const { t, i18n } = useTranslation('storage')

  const formatDate = (iso: string) =>
    DateTime.fromISO(iso).toLocaleString(DateTime.DATE_SHORT, {
      locale: i18n.language,
    })
  const title = areaTitle(area)
  const price = areaPriceFor(area, fromISO)
  const priceAmount =
    typeof price === 'number' ? fmtCurrency(price, i18n.language) : undefined

  return (
    <Modal.Notifications>
      <ContextNotification type="success">
        <div>
          <h4 className="text-xl font-semibold mb-4">{t`success.title`}</h4>
          <div>
            <strong>{title}</strong>{' '}
            {t('success.starts', { date: formatDate(fromISO) })}.
          </div>
          {priceAmount && (
            <div className="mt-4">
              <strong>{t('price.perMonth', { amount: priceAmount })}</strong>
            </div>
          )}
        </div>
      </ContextNotification>
    </Modal.Notifications>
  )
}
